import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import MasterServicesAgreementMDX from '@/markdown/master-services-agreement-7-16-24.mdx';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const MasterServicesAgreementPage = () => {
	return (
		<Layout pageName="master-services-agreement" title="Calm - Master Services Agreement">
			<MasterServicesAgreementMDX />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default MasterServicesAgreementPage;
